var RENDERS;
(function (RENDERS) {
    RENDERS["PUBLISHED_TIME"] = "MR_PUBLISHED_TIME.render";
    RENDERS["TITLE"] = "MR_TITLE.render";
    RENDERS["SUMMARY"] = "MR_SUMMARY.render";
    RENDERS["NORMALIZED_CATEGORY"] = "MR_NORMALIZED_CATEGORY.render";
    RENDERS["CAGR"] = "MR_CAGR.render";
    RENDERS["MARKET_INFOS"] = "MR_MARKET_INFOS.render";
    RENDERS["TAGS"] = "MR_TAGS.render";
    RENDERS["MENTIONED_ORGANIZATION"] = "MR_MENTIONED_ORGANIZATION.render";
})(RENDERS || (RENDERS = {}));
export const MARKET_COLUMNS_MAP = {
    PUBLISHED_TIME: {
        renderer: RENDERS.PUBLISHED_TIME,
        width: 160,
    },
    TITLE: {
        renderer: RENDERS.TITLE,
        width: 360,
    },
    SUMMARY: {
        renderer: RENDERS.SUMMARY,
        width: 300,
    },
    NORMALIZED_CATEGORY: {
        renderer: RENDERS.NORMALIZED_CATEGORY,
        width: 150,
    },
    CAGR: {
        renderer: RENDERS.CAGR,
        width: 150,
    },
    MARKET_INFOS: {
        renderer: RENDERS.MARKET_INFOS,
        width: 360,
    },
    TAGS: {
        renderer: RENDERS.TAGS,
        width: 360,
    },
    MENTIONED_ORGANIZATION: {
        renderer: RENDERS.MENTIONED_ORGANIZATION,
        width: 300,
    },
};
